export default {
    path: '/success',
    meta: {
        title: '下单成功',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/success`),
}


// WEBPACK FOOTER //
// ./src/views/Success/router.js